<template>
  <div>
    <GroupMasterLayout>
      <section class="mt-3 full__row_section">
        <div class="row">
          <div class="col-md-12">
            <div class="dashboard__card large_card card_padding indus_back_img">
              <div
                class="row make-row-hundred-percent align-items-center justify-content-center"
              >
                <div class="col-md-3 col-sm-12 mb-3">
                  <div
                    class="icon_wrapper centralize icon_div_big"
                    style="background-color: white; border-radius: 50%"
                  >
                    <svg
                      class="pl-1"
                      width="30"
                      height="30"
                      viewBox="0 0 16 18"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M6.85714 3.42845C6.8574 4.23888 6.57057 5.0232 6.04754 5.64226C5.52451 6.26132 4.7991 6.67509 4 6.81016V9.14273H10.2857C10.7404 9.14273 11.1764 8.96212 11.4979 8.64063C11.8194 8.31914 12 7.8831 12 7.42844V6.81016C11.1523 6.66688 10.3894 6.21039 9.86249 5.53115C9.33553 4.85191 9.08297 3.99949 9.15487 3.14283C9.22676 2.28616 9.61785 1.48776 10.2506 0.905846C10.8834 0.323933 11.7117 0.000976562 12.5714 0.000976562C13.4311 0.000976562 14.2594 0.323933 14.8922 0.905846C15.525 1.48776 15.9161 2.28616 15.988 3.14283C16.0599 3.99949 15.8073 4.85191 15.2804 5.53115C14.7534 6.21039 13.9905 6.66688 13.1429 6.81016V7.42844C13.1429 8.1862 12.8418 8.91293 12.306 9.44875C11.7702 9.98456 11.0435 10.2856 10.2857 10.2856H4V11.4753C4.84766 11.6186 5.61056 12.0751 6.13751 12.7543C6.66447 13.4335 6.91703 14.286 6.84513 15.1426C6.77324 15.9993 6.38215 16.7977 5.74936 17.3796C5.11656 17.9615 4.28825 18.2845 3.42857 18.2845C2.5689 18.2845 1.74059 17.9615 1.10779 17.3796C0.475002 16.7977 0.0839081 15.9993 0.0120164 15.1426C-0.0598754 14.286 0.192682 13.4335 0.719638 12.7543C1.24659 12.0751 2.00949 11.6186 2.85715 11.4753V6.8113C2.21271 6.70237 1.61283 6.41151 1.12819 5.97299C0.643555 5.53447 0.294357 4.96657 0.121743 4.33619C-0.0508719 3.70581 -0.0397113 3.03923 0.15391 2.41499C0.347531 1.79074 0.715545 1.23485 1.21459 0.812798C1.71363 0.39075 2.32291 0.120134 2.97064 0.0328391C3.61837 -0.0544564 4.27755 0.0452053 4.87052 0.320081C5.46349 0.594957 5.96554 1.03359 6.31751 1.58431C6.66949 2.13502 6.85672 2.77487 6.85714 3.42845Z"
                        fill="black"
                      />
                    </svg>
                  </div>
                </div>
                <div class="col-md-8 remove-padding-left">
                  <div class="text-left">
                    <h3 class="text-white font-weight">
                      {{ $t("text.iDashboard.allBranches") }}
                    </h3>
                  </div>
                  <div class="text-left">
                    <p class="text-white mt-4">
                      {{ $t("text.iDashboard.branchesTagline") }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <!-- TABLE -->
      <section class="my-5 full__row_section table-section mx-auto">
        <ejs-grid
          v-show="!showLoader"
          ref="dataGrid"
          :created="refreshGrid"
          :allowPaging="true"
          :allowSorting="true"
          :pageSettings="pageSettings"
          :toolbar="toolbar"
          :searchSettings="search"
          :allowExcelExport="true"
          :allowPdfExport="true"
          :toolbarClick="toolbarClick"
          :locale="usedLang"
        >
          <e-columns>
            <e-column width="60" field="index" headerText="#"></e-column>

            <e-column
              field="branchName"
              width="180"
              :headerText="$t('text.iBranchTank.site')"
            ></e-column>
            <!-- <e-column field="state" width="40" headerText="State"></e-column>
            <e-column field="street" width="40" headerText="Street"></e-column> -->
            <e-column
              field="totalCurrentVolume"
              width="180"
              :headerText="$t('text.iBranchTank.totalTankVolume')"
            ></e-column>
            <e-column
              field="maxCapacity"
              width="180"
              :headerText="$t('text.iBranchTank.maxVolume')"
            ></e-column>
            <e-column
              :template="actionButton"
              width="400"
              :headerText="$t('text.iBranchTank.action')"
            >
            </e-column>
          </e-columns>
        </ejs-grid>

        <TableLoader :showLoader="showLoader"></TableLoader>
      </section>
    </GroupMasterLayout>
  </div>
</template>

<script>
import GroupMasterLayout from "@/views/Industrial/GroupMasterLayout.vue";
import configObject from "@/config";
import TableLoader from "@/components/tableLoader/index";

import BranchActions from "../../../../components/TableTemplates/IndustrialAdmin/branchButtonGroup.vue";
import { VueperSlides, VueperSlide } from "vueperslides";
import "vueperslides/dist/vueperslides.css";

import {
  Page,
  Sort,
  Toolbar,
  Search,
  ExcelExport,
  PdfExport,
} from "@syncfusion/ej2-vue-grids";

import JQuery from "jquery";
let $ = JQuery;

export default {
  title: "Dashboard:: Epump Industrial Portal",
  name: "CompanyBranches",
  components: {
    GroupMasterLayout,
    TableLoader,
    VueperSlides,
    VueperSlide,
  },
  provide: {
    grid: [Page, Sort, Toolbar, Search, ExcelExport, PdfExport],
  },
  data() {
    return {
      usedLang: this.$store.getters.getLanguage,
      groupID: localStorage.getItem("groupID")
        ? localStorage.getItem("groupID")
        : this.$route.query.groupID,
      companyCumulativeWallet: null,

      showLoader: true,
      isDisabled: true,

      powerSource: "",
      industryBranch: null,
      industryBranchId: null,
      walletBalance: 0,
      consumptionstatus: "daily",
      year: "2020",

      actionButton: function () {
        return {
          template: BranchActions,
        };
      },

      pageSettings: { pageSizes: [12, 50, 100, 200], pageCount: 4 },
      toolbar: ["ExcelExport", "PdfExport", "Search"],
      search: { operator: "contains", ignoreCase: true },
    };
  },

  mounted() {},
  created() {
    this.getCompanyBranch();
  },
  methods: {
    getCompanyBranch() {
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Industrial/GroupBranches/${this.$route.query.groupID}`,
          configObject.authConfig()
        )
        .then((res) => {
          let index = 0;
          let countDownDays = [];
          let CountDownHours = [];
          res.data.forEach((el) => {
            el.index = ++index;
            el.totalCurrentVolume = el.totalCurrentVolume.toLocaleString(
              undefined,
              {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              }
            );

            el.maxCapacity = el.maxCapacity.toLocaleString();
          });
          this.showLoader = false;
          this.$refs.dataGrid.ej2Instances.setProperties({
            dataSource: res.data,
          });
          this.refreshGrid();
        })
        .catch((error) => {
          this.showLoader = false;
        });
    },

    refreshGrid() {
      this.$refs.dataGrid.refresh();
    },

    toolbarClick(args) {
      switch (args.item.text) {
        case "PDF Export":
          this.$refs.dataGrid.pdfExport();
          break;
        case "Excel Export":
          this.$refs.dataGrid.excelExport();
          break;
      }
    },
  },
};
</script>

<style scoped>
@media only screen and (max-width: 600px) {
  .full__row_section h3,
  .full__row_section p {
    font-size: 15px !important;
    text-align: center !important;
  }
}
.large_card {
  background-image: url("../../../../assets/img/longBG.png") !important;
  background-size: cover !important;
  background-position: 20% 20% !important;
}
</style>
